import { configureStore } from '@reduxjs/toolkit';
import gameStateReducer from './gameStateSlice';
import playerReducer from './playerSlice';
import waveReducer from './waveSlice';
import resourceReducer from './resourceSlice';
import announcementReducer from './announcementSlice';
import castleReducer from './castleSlice';
import trapReducer from './trapSlice';
import scoreReducer from './scoreSlice';

export const store = configureStore({
  reducer: {
    gameState: gameStateReducer,
    player: playerReducer,
    wave: waveReducer,
    resources: resourceReducer,
    announcement: announcementReducer,
    castle: castleReducer,
    trap: trapReducer,
    score: scoreReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 